module.exports = "/images/coffee-break.svg?3c46795eaa63981f59dce01128b9f9f1";